export enum RobDateStatusEnum {
    aolIncomplete = 1,
    incomplete = 2,
    complete = 3,
    noBunker = 4,
    exceededBunkerRefLimit = 5,
}
